<ng-container *transloco="let t; read: 'findMyAgent.results'">
  <section class="flex items-center space-x-4">
    <rma-profile-avatar class="aspect-square h-20 w-20" [avatar]="avatar" [lazyLoad]="false" profileType="Individual" target="_blank" />

    <div>
      <div class="text-steel-100 line-clamp-1 font-bold">{{ name }}</div>
      <div class="text-steel-80 line-clamp-1 text-sm">{{ agencyName }}</div>
      @if (showRatingSummary) {
        <rma-short-rating-summary [rating]="starRating" [count]="totalReviews" />
      }
    </div>
  </section>
</ng-container>
